/* UI-SPECIFIC CONSTANTS BELOW - CREATE SPARINGLY */
export const ENVIRONMENT_TYPES = {
  development: "development",
  remotedev: "remotedev",
  staging: "staging",
  production: "production",
};

// Toolbar settings for 'react-rte'
export const RICH_TEXT_TOOLBAR = {
  display: [
    "INLINE_STYLE_BUTTONS",
    "BLOCK_TYPE_BUTTONS",
    "BLOCK_TYPE_DROPDOWN",
    "LINK_BUTTONS",
  ],
  INLINE_STYLE_BUTTONS: [
    {
      label: "Bold",
      style: "BOLD",
      className: "custom-css-class",
    },
    {
      label: "Italic",
      style: "ITALIC",
    },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: "UL", style: "unordered-list-item" },
    { label: "OL", style: "ordered-list-item" },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: "Normal", style: "unstyled" },
    { label: "Heading 2", style: "header-two" },
    { label: "Heading 3", style: "header-three" },
    { label: "Heading 4", style: "header-four" },
  ],
};

export function getAppConstants() {
  const APP_CONSTANTS = window.APP_CONSTANTS || {};

  APP_CONSTANTS.RICH_TEXT_TOOLBAR = RICH_TEXT_TOOLBAR;
  APP_CONSTANTS.ENVIRONMENT_TYPES = ENVIRONMENT_TYPES;

  return APP_CONSTANTS;
}
